
export default {
  // Inicio de sesión
  login: {
    lang: 'Idioma',
    systemname: 'Login Facial',
    username: 'Usuario',
    username_label: 'Por favor ingrese el usuario',
    pwd: 'Contraseña',
    pwd_label: 'Por favor ingrese la contraseña',
    pwd_info: 'Ingrese el formato correcto de contraseña',
    success_msg: 'Inicio de sesión exitoso',
    error_name: 'Contraseña incorrecta',
    error_res: 'No cumple con los requisitos de inicio de sesión',
    login: 'Iniciar sesión',
  },
  // Barra lateral
  aside: {
    systemname: 'Panel Facial',
    quit: 'Salir',
    deviceControl: 'Control',
    basicSetting: 'Config.',
    workerSetting: 'Personal',
    deviceMonitoring: 'Monitor',
    recordManagement: 'Registros',
    securityManagement: 'La clave',
    tips: 'Aviso',
    tips_msg: '¿Desea cerrar sesión?',
  },
  // Control de dispositivo
  control: {
    remoteControl: 'Remoto',
    restart: 'Reiniciar',
    clickToRestart: 'Clic para reiniciar',
    restartConfirm: '¿Seguro que desea reiniciar?',
    restartSuccess: 'Reinicio exitoso',
    restartFailed: 'Reinicio fallido',
    remoteOpen: 'Abrir puerta de forma remota',
    clickToOpen: 'Clic para abrir',
    openConfirm: '¿Seguro que desea abrir remotamente?',
    remoteOpenSuccess: 'Apertura exitosa',
    remoteOpenFailed: 'Apertura fallida',
    reset: 'Restablecer dispositivo',
    clickToReset: 'Clic para restablecer',
    resetConfirm: '¿Seguro que desea restablecer?',
    resetSuccess: 'Restablecimiento exitoso',
    resetFailed: 'Restablecimiento fallido',
    firmwareUpgrade: 'Actualización de firmware',
    upgradeConfig: 'Config. de actualización',
    firmwareUrl: 'URL del firmware',
    md5Checksum: 'Valor md5',
    startUpgrade: 'Iniciar actualización',
    urlRequired: 'La URL es obligatoria',
    md5Required: 'El md5 es obligatorio',
    urlInvalid: 'Ingrese una URL válida',
    md5Invalid: 'Ingrese un md5 válido',
    upgradeConfirm: '¿Confirmar actualización?',
    upgradeSuccess: 'Actualización exitosa',
    clearFile: "Borrar archivo",
    uploading: 'Subiendo...',
    uploadAndUpgrade: 'Subir y actualizar',
    restartTips: 'Reinicio seguro, no se perderán datos',
    restarting: 'Reiniciando...',
    remoteTips: 'Control remoto de acceso',
    opening: 'Abriendo...',
    resetTips: 'Restaurar de fábrica, borrará datos',
    reseting: 'Restableciendo...',
    urlUpgrade: 'Actualización por URL',
    fileUpgrade: 'Subida de archivo',
    uploadFile: 'Clic para subir firmware',
    formatFile: 'Soporta .zip o .dpk, máx 20MB',
    fileName: 'Nombre',
    size: 'Tamaño',
  },
  // Configuración
  config: {
    second: 's',
    millisecond: 'ms',
    min: 'minutos',
    notsave: 'No guardar',
    save: 'Guardar',
    noVoice: 'Sin voz',
    no: 'No',
    yes: 'Sí',
    // Básico
    basicConfiguration: 'Configuración básica',
    displaySettings: 'Pantalla',
    informationDisplay: 'Mostrar información',
    audioSettings: 'Audio',
    languageAndThemes: 'Idioma y tema',
    autoAdjustScreenBrightness: 'Brillo automático',
    screenBrightness: 'Brillo de pantalla',
    autoTurnOffScreen: 'Apagado automático',
    autoTurnOffScreenTime: 'Tiempo de apagado',
    autoScreenSaver: 'Salvapantallas automático',
    autoScreenSaverTime: 'Tiempo de salvapantallas',
    displayDeviceSn: 'Mostrar SN',
    displayIp: 'Mostrar IP',
    displayIdentityCard: 'Mostrar credencial en la nube',
    volume: 'Volumen',
    language: 'Idioma',
    displayCode: "Mostrar código de miniapp",
    themeMode: "Tema",
    cn: 'Chino',
    en: 'Inglés',
    es: 'Español',
    fr: 'Francés',
    de: 'Alemán',
    ru: 'Ruso',
    ar: 'Árabe',
    pt: 'Port.',
    ko: 'Coreano',
    standardMode: 'Modo estándar',
    simpleMode: 'Modo simple',
    firstLogin: 'Primer inicio de sesión',
    backlight: 'Luz de fondo',
    brightness: 'Luz blanca',
    nirBrightness: 'Luz IR',
    never: 'Nunca',
    min1: '1 minuto',
    min2: '2 minutos',
    min3: '3 minutos',
    min4: '4 minutos',
    min5: '5 minutos',
    // Red
    networkConfiguration: 'Red',
    otherConfiguration: 'Otros',
    ipConfiguration: 'IP',
    devicePassword: 'Contraseña del dispositivo',
    protocolPassword: 'Contraseña de protocolo',
    networkType: 'Tipo de red',
    ethernet: 'Ethernet',
    wifiName: 'Wi‑Fi',
    wifiPassword: 'Contraseña Wi‑Fi',
    dhcpModeSelection: 'Modo DHCP',
    dhcpMode: 'Automático',
    customNetworkConfiguration: 'Manual',
    ipAddress: 'IP',
    gateway: 'Puerta de enlace',
    subnetMask: 'Máscara de subred',
    dnsServer: 'DNS',
    mac: 'MAC de red',
    // MQTT
    mqttRelatedConfiguration: 'MQTT',
    mqttConnectionInformation: 'Conexión MQTT',
    sessionConfiguration: 'Sesión',
    serverAddress: 'Servidor',
    clientID: 'ID de cliente',
    userName: 'Usuario',
    userPassword: 'Contraseña',
    topicPrefix: 'Prefijo de tema',
    onlineChecking: 'Verificación en línea',
    onlineCheckingTimeout: "Tiempo de espera",
    cleanSession: 'Limpiar sesión',
    clientIdSuffix: 'Sufijo de ID',
    willTopic: 'Tema de voluntad',
    enterpriseWechat:'Modo WeChat Enterprise sin efecto',
    // Rostro
    faceRelatedConfiguration: 'Configuración facial',
    functionalInformation: 'Función',
    prompt: 'Mensaje',
    faceSimilarityThreshold: 'Umbral de similitud',
    livenessDetectionFunction: 'Detección de vivacidad',
    livenessDetectionThreshold: 'Umbral de vivacidad',
    infraredImageDisplay: "Mostrar infrarrojo",
    maskRecognition: "Reconocer mascarilla",
    strangerVoice: "Voz de desconocido",
    voiceMode: "Modo de voz",
    voiceModeDate: 'Saludo personalizado',
    imageSaveType: "Tipo de guardado",
    saveStrangerImage: "Guardar imagen de desconocido",
    fullView: "Panorámica",
    face: "Rostro",
    broadcastPleaseRegisterFirst: 'Reproducir “Registre primero”',
    broadcastHelloStranger: 'Reproducir “Desconocido”',
    broadcastName: 'Reproducir nombre',
    broadcastGreeting: 'Reproducir saludo personalizado',
    greeting: 'Saludo',
    broadcastWelcome: 'Reproducir "Bienvenido"',
    recognitionSwitch: 'Interruptor de re-detección',
    // Sistema
    systemRelatedConfiguration: 'Sistema',
    functionSwitch: 'Interruptores',
    cardSwipingSwitch: 'Tarjeta',
    passwordSwitch: 'Contraseña',
    strangerImage: 'Imagen de desconocido',
    cloudCertificateSwitch: 'Certificado en la nube',
    physicalCardNumber: 'Número de tarjeta física',
    cloudCertificateAcquisition: 'Obtención de certificado en la nube',
    heartbeatConfig: 'Heartbeat',
    heartbeatSwitch: 'Heartbeat on/off',
    heartRateInterval: 'Intervalo',
    heartbeatTopic: 'Tema heartbeat',
    heartbeatContent: 'Contenido',
    basicInformation: 'Información básica',
    deviceMac: 'MAC',
    uuid: 'UUID',
    sn: 'SN',
    model: 'Modelo',
    version: "Versión",
    appVersion: "Versión de firmware",
    releaseTime: "Hora de actualización",
    totaldisk: 'Espacio total',
    freedisk: 'Espacio restante',
    // Paso
    passageConfiguration: 'Paso',
    functionConfiguration: 'Funciones',
    numberOfPassageRecords: 'Máx. registros',
    durationOfRelayOpening: 'Duración del relé',
    alarmSwitch: 'Alarma',
    fireAlarmSwitch: 'Alarma de incendios',
    fireAlarmStatus: 'Estado de incendios',
    normal: 'Normal',
    warning: 'Aviso',
    tamperSwitch: 'Antimanipulación',
    uploadToCloudSwitch: 'Interruptor de carga facial',
    // Reloj
    clockConfiguration: 'Reloj',
    timeSynchronizationSwitch: 'Sincronización horaria',
    timeSynchronizationServerIP: 'Servidor de tiempo',
    timedSynchronizationTime: 'Hora de sincronización',
    timeZone: 'Zona horaria',
    setDeviceTime: 'Configurar hora',
    restartAfterSetting: 'El dispositivo se reiniciará',
    // Activación de certificado en la nube
    cloudCertificateActivation: 'Activación de certificado',
    activationKey: 'Clave de activación',
    cloudTips1: 'Ingrese la clave sin espacios',
    cloudTips2: 'Tras activar, conectará al servicio de autenticación',
    confirmActivation: 'Confirmar activación',
    activationInProgress: 'Activando...',
    activationFailed: 'Activación fallida',
    activationSuccessful: 'Activación exitosa',
    // Cambio de contraseña
    passwordModification: 'Cambiar contraseña',
    password: 'Contraseña',
    oldPassword: 'Contraseña anterior',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    passwordRule: 'Recomendación de contraseña',
    passwordLength: 'Longitud ≥6',
    cannotBeTheSame: 'No puede ser todos los caracteres iguales',
    cannotOrder: 'No incluir 3+ números/letras consecutivos',
    cannotWeakPassword: 'No usar contraseñas débiles comunes',
    submit: 'Enviar',
    saveConfig: 'Guardar',
    // Mensajes
    msg_please_enter: 'Ingrese contenido',
    msg_inputPassword: 'Ingrese contraseña',
    msg_oldPasswordError: 'Contraseña anterior incorrecta',
    msg_password_mismatch: 'Las contraseñas no coinciden',
    msg_password_min_length: 'Mínimo 6 caracteres',
    msg_is_weak_password: 'Contraseña débil, cambie',
    msg_pswChangeSuccessAndLogin: 'Cambio exitoso, inicie sesión',
    msg_pswChangeSuccess: 'Cambio de contraseña exitoso',
    msg_pswChangeFail: 'Cambio de contraseña fallido',
    msg_saveSuccess: 'Guardado exitoso',
    msg_saveFail: 'Guardado fallido',
    msg_formFilled: 'Revise el formulario',
    msg_number_0_23: 'Solo 0-23',
    msg_number_0_24: 'Solo 0-24',
    msg_noChange: 'No hay cambios de configuración para guardar',
    // Configuración de recursos
    resourceConfiguration: 'Configuración de recursos',
    backgroundImage: 'Imagen de fondo',
    selectImage: 'Seleccionar imagen',
    uploadBackground: 'Subir fondo',
    uploading: 'Subiendo...',
    backgroundUploadTip: 'Suba una imagen PNG; se convertirá a Base64 y se enviará al dispositivo',
    backgroundResolutionMismatch: 'La resolución de la imagen debe ser {n}',
    backgroundRequired: 'Seleccione una imagen de fondo',
    backgroundImageOnlyPNG: 'Solo imágenes PNG',
    backgroundSizeLimit: 'La imagen no debe exceder 5MB',
    backgroundParseFailed: 'Error al leer imagen, reintente',
    backgroundImageSelected: 'Imagen seleccionada',
    backgroundSuccess: 'Fondo subido',
    backgroundFailed: 'Error al subir fondo',
    scanSettings: 'Configuración de escaneo',
    scanSwitch: 'Interruptor de Escaneo',
    scanInterval: 'Intervalo de escaneo',
  },
  // Gestión de personal
  person: {
    idCard: 'Número de ID',
    userType: 'Tipo de persona',
    administrator: 'Administrador',
    userId: 'ID',
    user: 'Usuario',
    voucher: 'Credencial',
    permission: 'Permiso',
    addUser: 'Añadir persona',
    name: 'Nombre',
    editUser: 'Editar persona',
    placeholderUserId: 'Ingrese ID de usuario',
    placeholderName: 'Ingrese nombre',
    userNotExist: 'La persona no existe',
    oneClickClear: 'Borrar todo',
    clearTips: 'Se borrarán todos los datos, ¿continuar?',
    clearSuccess: 'Borrado exitoso',
    clearFailed: 'Borrado fallido',
  },
  voucher: {
    password: 'Contraseña',
    card: 'Tarjeta',
    face: 'Rostro',
    finger: 'Huella',
    code: 'Código',
    codeType: 'Tipo de código',
    passthroughCode: 'Código de paso',
    staticCode: 'Código estático',
    dynamicCode: 'Código dinámico',
    placeholderCode: 'Por favor ingrese certificado de código',
    placeholderPwd: 'Ingrese la credencial de contraseña',
    placeholderCard: 'Ingrese la credencial de tarjeta',
    validPassword: 'Ingrese 6 dígitos',
    validCard: 'Ingrese 8 dígitos o letras',
    photoRegistration: 'Registro de foto',
    featureValueRegistration: 'Registro de rasgos',
    fingerRegistration: 'Registro de huella',
    fingerFeatureRegistration: 'Registro por valor de característica',
    fingerInput: 'Coloque el dedo en el lector de huellas',
    fingerRemainingTime: 'Tiempo restante',
    fingerInputting: 'Registrando...',
    startFingerInput: 'Iniciar registro de huella',
    fingerInputTips: 'Ingrese el valor de característica de la huella',
    fingerWaitInput: 'En espera de registro',
    fingerInputNow: 'Registrando huella...',
    fingerInputSuccess: 'Registro exitoso',
    fingerInputFailed: 'No se pudo iniciar el registro de huella',
    fingerReTry: 'Fallo en el registro de huella, inténtelo de nuevo',
    fingerFilled: 'Registro de huella exitoso, el valor de característica se ha rellenado automáticamente',
    fingerFailed: 'Fallo en el registro de huella',
    fingerTimeout: 'Tiempo de espera agotado',
    fingerInputTimeout: 'Tiempo de espera del registro de huella, inténtelo de nuevo',
    fingerError: 'Registro fallido',
    fingerInputError: 'Fallo en el registro de huella, inténtelo de nuevo',
    fingerInputed: 'Huella registrada',
    fingerReInput: 'Volver a registrar la huella',
  },

  permission: {
    deletePermission: 'Eliminar permiso',
    addPermission: 'Añadir permiso',
    permissionId: 'ID de permiso',
    userId: 'ID de usuario',
    timeRange: 'Intervalo de tiempo',
    extra: 'Extra',
    effectiveType: 'Tipo de vigencia',
    effectiveTime: 'Tiempo efectivo',
    effectiveWeek: 'Semana efectiva',
    timePeriod: 'Periodo',
    addTimePeriod: 'Añadir periodo',
    modify_previous_time: 'Primero modifique el periodo previo',
    cannot_be_earlier: 'La hora final no puede ser menor que la inicial',
    times_cannot_overlap: 'Los tiempos no pueden superponerse',
    choose_time_range: 'Seleccione rango de tiempo',
    unlimitedMode: 'Sin límite',
    usualMode: 'Modo habitual',
    dailyMode: 'Modo diario',
    weeklyRepetitionMode: 'Repetición semanal',
    time_range: 'Rango',
  },

  common: {
    startDate: 'Fecha inicio',
    endDate: 'Fecha fin',
    to: 'a',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    delete: 'Eliminar',
    edit: 'Editar',
    batchDelete: 'Eliminación masiva',
    startTime: 'Hora inicio',
    endTime: 'Hora fin',
    monday: 'Lunes',
    tuseday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saterday: 'Sábado',
    sunday: 'Domingo',
    placeholder: 'Por favor ingrese',
    placeholderSelect: 'Por favor seleccione',
    closeTips: '¿Confirmar cierre?',
    deleteTips: '¿Confirmar eliminación?',
    deleteSuccess: 'Eliminado con éxito',
    addSuccess: 'Añadido con éxito',
    editSuccess: 'Editado con éxito',
    saveSuccess: 'Guardado con éxito',
    tips: 'Aviso',
    operation: 'Operación',
    query: 'Consulta',
    reset: 'Reset',
    noData: 'Sin datos por ahora',
    export: 'Exportar',
    success: 'Éxito',
    failure: 'Fallo',
    incorrectFormat: 'Formato incorrecto',
    integerFormat: 'Debe ser entero ≥0',
    positiveIntegerFormat: 'Debe ser entero >0',
    noDataSaved: 'No hay datos para guardar',
    chinese: 'Chino',
    english: 'Inglés',
    spanish: 'Español',
    french: 'Francés',
    german: 'Alemán',
    russian: 'Ruso',
    arabic: 'Árabe',
    portuguese: 'Portugués',
    korean: 'Coreano',
    detail: 'Detalle',
    clearTips: '¿Confirmar borrado?',
    clearSuccess: 'Borrado exitosamente',
  },

  log: {
    accessMethod: 'Método de acceso',
    passingTime: 'Hora de paso',
    accessPass: 'Credencial de paso',
    accessResult: 'Resultado',
    accessPhoto: 'Foto',
    viewPhotos: 'Ver fotos'
  },

  error: {
    networkError: 'Error de red, verifique su conexión',
    timeout: 'Tiempo de espera agotado, reintente',
    serverError: 'Error interno del servidor, reintente',
    notFound: 'El recurso no existe',
    unauthorized: 'No autorizado, inicie sesión',
    noResponse: 'No hay respuesta del servidor',
    unknownError: 'Error de solicitud, código:',
    requestFailed: 'Solicitud fallida'
  },

  security: {
    keyId: 'ID de clave',
    keyType: 'Tipo de clave',
    keyEncoding: 'Codificación de clave',
    keyValue: 'Valor de clave',
    startTime: 'Hora de inicio',
    expirationTime: 'Hora de expiración',
    newKey: 'Agregar clave',
    clearKey: 'Borrar clave',
    validTime: 'Tiempo válido',
  }
}

